module.exports = __webpack_public_path__ + "img/stena30.16a06025.jpg";